import script from "./SolutionIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionIndex.vue?vue&type=script&setup=true&lang=js"

import "./SolutionIndex.vue?vue&type=style&index=0&id=29692972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29692972"]])

export default __exports__